// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const PartialDebit = t.struct({
    adjustmentType: KeyValuePair,
    amount: t.maybe(t.Number),
    currency: KeyValuePair,
    description: t.String,
    guid: t.String,
    itemNumber: t.String,
    itemType: t.String,
    material: t.String,
    quantity: t.maybe(t.Number),
    unit: KeyValuePair,
    valueOfAdjustment: t.maybe(t.Number)
}, {
    name: 'PartialDebit',
    strict: true
});

export const getDefaultState = () => new PartialDebit({
    adjustmentType: getKeyValuePairDefaultState(),
    amount: null,
    currency: getKeyValuePairDefaultState(),
    description: '',
    guid: '',
    itemNumber: '',
    itemType: '',
    material: '',
    quantity: null,
    unit: getKeyValuePairDefaultState(),
    valueOfAdjustment: null
});

export default PartialDebit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/partial-debit.js